import { render, staticRenderFns } from "./_header.vue?vue&type=template&id=b20a7d38&scoped=true&"
import script from "./_header.vue?vue&type=script&lang=js&"
export * from "./_header.vue?vue&type=script&lang=js&"
import style0 from "./_header.vue?vue&type=style&index=0&id=b20a7d38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20a7d38",
  null
  
)

export default component.exports